import React from "react";
import PopupBodyItem from "../../Helpers/Popup/PopupParts/PopupBodyItem";
import { formatDate } from "../../../JsHelpers/DateFormat";
import trans from "../../../utils";
import { Tag } from "antd";

export default function SubmittalsInf({ values = {}, statusColors }) {
  const getValue = (value, defaultValue = "-----") =>
    value ? value : defaultValue;
  const {
    submittalNumber,
    currentRevision,
    type = "",
    description,
    discipline = "",
    status = "",
    targetReviewDate = "",
    reviewedByQA,
    reviewedByConsultant,
  } = values;
  const formattedSubmittedAt = targetReviewDate
    ? formatDate(targetReviewDate).formattedDate
    : "-----";
  return (
    <div>
      <p className="fs-16 fw-700 brand-700 text-uppercase">
        {trans("Submittal Details")}
      </p>
      <div className="row">
        <div className="col-lg-6">
          <div className="display-border">
            <PopupBodyItem
              title={trans("Submittal Number")}
              item={getValue(submittalNumber)}
            />
            <PopupBodyItem
              title={trans("Current Revision")}
              item={getValue(currentRevision)}
            />
            <PopupBodyItem title={trans("Type")} item={trans(getValue(type))} />
            <PopupBodyItem
              title={trans("Discipline")}
              item={trans(getValue(discipline))}
            />
            <PopupBodyItem
              title={trans("Project")}
              item={getValue(values?.project?.name)}
            />
            <PopupBodyItem
              title={trans("Submitted By")}
              item={getValue(values?.submittedBy?.name)}
            />{" "}
            <PopupBodyItem
              title={trans("Reviewed By Consultant")}
              item={getValue(values?.reviewedByConsultant?.name)}
            />
          </div>
        </div>
        <div className="col-lg-6">
          <div className="display-border">
            <PopupBodyItem
              title={trans("Project")}
              item={getValue(values?.project?.name)}
            />
            <PopupBodyItem
              title={trans("Description")}
              item={getValue(description)}
            />

            <PopupBodyItem
              title={trans("Status")}
              item={getValue(
                <Tag color={statusColors[status] || "default"}>
                  {trans(status)}
                </Tag>,
              )}
            />
            <PopupBodyItem
              title={trans("Review Date")}
              item={getValue(formattedSubmittedAt)}
            />
            <PopupBodyItem
              title={trans("Reviewed By QA")}
              item={getValue(values?.reviewedByQA?.name)}
            />
          </div>
        </div>
      </div>
      {/* Attachments intentionally live only under the revision tabs: a file belongs
          to the review cycle it was submitted in, not to the submittal as a whole. */}
    </div>
  );
}
